import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Grid, Button, Box, CircularProgress } from "@mui/material";

const InstagramReels = () => {
  const [videos, setVideos] = useState([]);
  const [filterVideos, setFilterVideos] = useState([]);
  const [folderId, setFolderid] = useState('17hvuOBZNW_mQv7oBGuIxBwmRiKw3cb_f');
  const [loading, setLoading] = useState(true); // Loading state
  const [visibleVideos, setVisibleVideos] = useState(8); // For pagination
  const navigate = useNavigate();

  const allTags = [
    "hindu",
    "muslim",
    "savethedate",
    "engagement",
  ];
  const [selectedTag, setSelectedTag] = useState("hindu");
  const muslim = "1iw6JjXENuK_HlJ1pf7QGC7ltPVnb8Qap";
  const engagement = '1JDD2kX3Zf0e0kciQA-BLvvZaZ2zlJZVc';
  const hindu = '17hvuOBZNW_mQv7oBGuIxBwmRiKw3cb_f';
  const savethedate = '1JV7onNWu2zG5_COMlh4YL5iPe85NjOxt';
  const API_KEY = "AIzaSyAloV8bVCm-pqv7im1WGZ7YqiGCCuTEuMI";

  useEffect(() => {
    const fetchVideos = async () => {
      const lastFetchTimeKey = `lastFetchTime_${selectedTag}`;
      const cachedVideosKey = `${selectedTag}`;
      const lastFetchTime = localStorage.getItem(lastFetchTimeKey);
      const currentTime = new Date().getTime();
  
      if (lastFetchTime && currentTime - lastFetchTime < 3600000) {
        // Fetch from cache
        const cachedVideos = JSON.parse(localStorage.getItem(cachedVideosKey));
        if (cachedVideos) {
          setVideos(cachedVideos);
          setFilterVideos(cachedVideos);
          setLoading(false);
          return;
        }
      }
  
      setLoading(true);
      try {
        const response = await axios.get(
          `https://www.googleapis.com/drive/v3/files?q='${folderId}'+in+parents&key=${API_KEY}&fields=files(id,name,mimeType,webContentLink)`
        );
        const videoFiles = response.data.files.filter((file) =>
          file.mimeType.includes("video")
        );
  
        // Cache the videos and fetch time
        localStorage.setItem(cachedVideosKey, JSON.stringify(videoFiles));
        localStorage.setItem(lastFetchTimeKey, currentTime.toString());
        setVideos(videoFiles);
        setFilterVideos(videoFiles);
      } catch (error) {
        console.error("Error fetching videos:", error);
        setVideos([]);
        setFilterVideos([]);
      } finally {
        setLoading(false);
      }
    };
  
    fetchVideos();
  }, [selectedTag, folderId]);  

  const handleTagClick = useCallback((tag) => {
    setSelectedTag(tag);
    if (tag === "hindu") {
      setFolderid(hindu);
    } else if (tag === "muslim") {
      setFolderid(muslim);
    } else if (tag === "savethedate") {
      setFolderid(savethedate);
    } else if (tag === "engagement") {
      setFolderid(engagement);
    } 
  }, []);

  const loadMoreVideos = () => {
    setVisibleVideos((prev) => prev + 8); // Increment visible videos
  };

  const makeABooking = (_, video) => {
    localStorage.setItem("cart", JSON.stringify(video));
    navigate(`/booking?id=${video?.id}`);
  };

  const capitalize = (text) =>
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: "2rem", backgroundColor: "#f9e9c8" }}>
      {/* Filter Buttons */}
      <Box sx={{ marginBottom: "20px" }}>
        {allTags.map((tag) => (
          <button
            key={tag}
            onClick={() => handleTagClick(tag)}
            style={{
              margin: "5px",
              padding: "10px 15px",
              backgroundColor: selectedTag === tag ? "#BA9F52" : "#FFF",
              border: "1px solid #BA9F52",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {capitalize(tag) + ' Theme'}
          </button>
        ))}
      </Box>

      {/* Video Grid */}
      <Grid container spacing={2}>
        {filterVideos.slice(0, visibleVideos).map((video) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            key={video?.id}
          >
            <Box
              sx={{
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                backgroundColor: "#FFF",
              }}
            >
              <iframe
                loading="lazy"
                src={`https://drive.google.com/file/d/${video.id}/preview`}
                height="500"
                allow="autoplay"
                style={{ border: "none", width: "100%" }}
                title={`edigital Video ${video.id}`}
              ></iframe>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "#BA9F52",
                  color: "#FFF",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  borderRadius: "0 0 8px 8px",
                  "&:hover": {
                    backgroundColor: "#A28847",
                  },
                }}
                onClick={(e) => makeABooking(e, video)}
              >
                Book Now
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Load More Button */}
      {visibleVideos < filterVideos.length && (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#BA9F52", textColor: "#FFF" }}
            onClick={loadMoreVideos}
          >
            Load More
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default InstagramReels;

